import { render, staticRenderFns } from "./multilingual.vue?vue&type=template&id=27cb4031&scoped=true"
import script from "./multilingual.vue?vue&type=script&lang=js"
export * from "./multilingual.vue?vue&type=script&lang=js"
import style0 from "./multilingual.vue?vue&type=style&index=0&id=27cb4031&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cb4031",
  null
  
)

export default component.exports